export enum WebSocketStoreKeys {
  Onboarding = 'onboarding',
}
